import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
    ButtonLinkWithIcon,
    ButtonWithIcon
} from '@zoopla/blueprint-button-with-icon';

export const DynamicNumberLink = styled(ButtonLinkWithIcon)();
export const DynamicNumberButton = styled(ButtonWithIcon)(css`
    &[disabled] {
        background-color: inherit;
        color: inherit;
    }
`);
